import { Button, Card } from '@features/ui';
import { useAuthStore } from '@src/stores/authStore';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const ActiveSubscriptions = () => {
  const { t } = useTranslation();
  const { auth } = useAuthStore();
  const navigate = useNavigate();

  const competitionActivationDate = auth?.user?.competitionActivationDate;

  const renderPendingActivation = () => {
    if (!competitionActivationDate) {
      return null;
    }

    if (dayjs.utc().isAfter(dayjs.utc(competitionActivationDate))) {
      return null;
    }

    return (
      <span className={'text-sm text-yellow-500 font-medium'}>
        - Pending waiting to activate on{' '}
        {dayjs.utc(competitionActivationDate).format('MMM DD')}
      </span>
    );
  };

  const formatDate = (value?: string | Date | number) => {
    if (!value) return '';
    const date =
      typeof value === 'string' || typeof value === 'number'
        ? new Date(value)
        : value;

    if (Number.isNaN(date.getTime())) return String(value);
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const day = String(date.getDate()).padStart(2, '0');
    const mon = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${mon} ${year}`;
  };

  return (
    <div className={'flex-row'}>
      <h1 className={'text-2xl font-medium'}>
        {t('dashboard.activeSubscriptions')}
      </h1>
      <Card className={'flex-row mt-5 justify-between items-center'}>
        <div className={'flex flex-col gap-y-2.5'}>
          <p className={'text-base font-medium'}>
            {auth?.user?.accountName} {renderPendingActivation()}
          </p>

          <p className={'text-sm font-medium text-muted-foreground'}>
            Created on {formatDate(auth?.user?.createdAt)}
          </p>
        </div>
        <div className={'flex gap-x-5'}>
          <Button
            className={'text-base font-bold'}
            size={'lg'}
            variant={'gradient'}
            onClick={() => navigate('/profile')}
          >
            {t('dashboard.viewDetails')}
          </Button>
          <Button
            className={'text-base font-bold'}
            size={'lg'}
            variant={'gradient'}
            onClick={() => navigate('/market-data')}
          >
            {t('dashboard.purchase')}
          </Button>
        </div>
      </Card>
    </div>
  );
};
